<template>
  <div class="contentWrapper">
    <div class="content content--big">
      <span class="label">{{ $t('Web.Profile.Contakt') }}</span>
      <span>{{ $t('Web.Hotline.Title') }}</span>
      <span class="secondary">{{ $t('Web.Hotline.Text') }}</span>
    </div>
    <div class="content content--dark">
      <a href="mailto:service.junelight@suncycle.eu">
        <span class="icon icon--email">service.junelight@suncycle.eu</span>
      </a>
    </div>
    <div class="content content--dark content--big">
      <div class="phone">
        <a href="tel: 0800 112 526" class="austria">
          <span class="icon icon--call"> <i class="country austria"></i>0800 112 526 </span>
        </a>
        <a href="tel: 0800 586 3544" class="germany">
          <span class="icon icon--call"> <i class="country germany"></i>0800 586 354 448 </span>
        </a>
      </div>
      <div class="phone phone--second-row">
        <a href="tel: 0800 563 358" class="switzerland">
          <span class="icon icon--call"> <i class="country switzerland"></i>0800 563 358 </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicePerson',
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
.contentWrapper {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.content {
  padding: 16px;
  height: 40px;
  background: $white;
  border: solid 1px $cloudy-blue;
  background: #fff;

  span {
    @include textCharts;
    color: $petrol;
    display: block;
  }

  .icon,
  .icon a {
    @include textSmall;
    text-align: center;
    color: $charcoal-grey;
  }

  .label {
    @include textSmall;
    color: $bluey-grey;

    & ~ span {
      padding: 10px 0 0 20px;

      &.secondary {
        color: $charcoal-grey;
        padding-top: 6px;
      }
    }
  }

  @include siblings-by-count(1, &) {
    border-radius: 8px;
  }

  @include siblings-by-count(2, &) {
    border-bottom: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    & ~ :nth-of-type(2) {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  @include siblings-by-count(3n, &) {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    & ~ :nth-of-type(2) {
      border-bottom: 0;
      border-top: 0;
      border-radius: 0;
    }
    & ~ :nth-of-type(3) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  &:first-child:nth-last-child(1) {
    border-radius: 8px;
    border: solid 1px $cloudy-blue;
  }

  &--big {
    height: auto;
  }

  &--dark {
    background: $cloudy-blue-20;

    span {
      @include textSmall;
      line-height: 1.38;
      color: $bluey-grey;
    }
  }
}

.phone {
  display: flex;

  &--second-row {
    margin-top: 25px;
  }

  a {
    flex: 0 0 50%;
    text-align: center;

    span {
      display: inline;
    }
  }

  .country {
    display: inline-block;
    height: 20px;
    width: 35px;
    position: relative;
    top: 5px;
    margin-right: 6px;

    &.germany {
      background: url('../../assets/img/country_germany.svg') no-repeat center center;
      background-size: contain;
    }

    &.austria {
      background: url('../../assets/img/country_austria.svg') no-repeat center center;
      background-size: contain;
    }

    &.switzerland {
      background: url('../../assets/img/country_switzerland.svg') no-repeat center center;
      background-size: contain;
    }
  }
}

.icon {
  display: block;
  width: inherit;
  height: inherit;

  &:before {
    display: block;
    width: 100%;
    height: 20px;
    content: '';
    margin: 0 0 3px 0;
    transition: background 0.25s ease-out;
  }

  &--email {
    &:before {
      background: url('../../assets/img/ico-email-active.svg') no-repeat center center;
    }
  }
  &--call {
    &:before {
      background: url('../../assets/img/ico-call-active.svg') no-repeat center center;
    }
  }
}
</style>
